import React from 'react'
import {
  NewsBigBox,
  NewsBigDesc,
  NewsSmallBox,
  NewsSmallContent,
  NewsSmallDesc,
  NewsSmallImage,
  PromotionTitleWrapper,
  PromotionWrapper,
} from './PromotionStyled'
import { Col, Row } from 'antd'
import { Container, ContentWrapper, IntroDescription, IntroTitle } from '../CommonStyled/CommonStyled'
import { useInView } from 'react-intersection-observer'
import { Fade } from 'react-awesome-reveal'
import config from '../../config'
import { buildPath } from '../../utils/common'

const Promotion = props => {
  const { id, promotionData } = props
  const { ref: myRef, inView: myElementIsVisible } = useInView()

  function splitArrayIntoChunks(array, chunkSize) {
    const result = []
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize))
    }
    return result
  }

  const renderNews = () => {
    if (!promotionData || promotionData?.events?.length === 0) return
    const newData = splitArrayIntoChunks(promotionData?.events, 3)
    // console.log(promotionData?.events)
    // console.log(newData)
    return (
      newData &&
      newData.map((row, indexRow) => (
        <Row gutter={[16, 16]} style={{ marginTop: 16 }} align={'stretch'} key={indexRow}>
          {row[0] && (
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <NewsBigBox href={row[0].link} target={'_blank'} background={buildPath(row[0].image)}>
                <NewsBigDesc>{row[0].description}</NewsBigDesc>
              </NewsBigBox>
            </Col>
          )}
          <Col
            xxl={12}
            xl={12}
            lg={12}
            md={12}
            sm={24}
            xs={24}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            {row[1] && (
              <NewsSmallBox target={'_blank'} href={row[1].link}>
                <NewsSmallImage>{row[1].image && <img src={buildPath(row[1].image)} alt={''} />}</NewsSmallImage>
                <NewsSmallContent>
                  <NewsSmallDesc>{row[1].description}</NewsSmallDesc>
                </NewsSmallContent>
              </NewsSmallBox>
            )}
            {row[2] && (
              <NewsSmallBox target={'_blank'} href={row[2].link}>
                <NewsSmallImage>{row[2].image && <img src={buildPath(row[2].image)} alt={''} />}</NewsSmallImage>
                <NewsSmallContent>
                  <NewsSmallDesc>{row[2].description}</NewsSmallDesc>
                </NewsSmallContent>
              </NewsSmallBox>
            )}
          </Col>
        </Row>
      ))
    )
  }

  return (
    <Container>
      <PromotionWrapper ref={myRef} id={id}>
        <ContentWrapper>
          <PromotionTitleWrapper>
            <Fade key={myElementIsVisible} direction="down" duration={500}>
              <IntroTitle>{promotionData?.title}</IntroTitle>
              <IntroDescription>{promotionData?.commonDescription}</IntroDescription>
            </Fade>
          </PromotionTitleWrapper>
          {renderNews()}
        </ContentWrapper>
      </PromotionWrapper>
    </Container>
  )
}

Promotion.propTypes = {}

export default Promotion
